//@flow
import React, {useRef} from 'react';

import {makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    zIndex: 10,
  },
}));

type Props = {
  children: React$Node,
  open: boolean,
};

export default function PinnedContent(props: Props) {
  const {children, open} = props;
  const classes = useStyles();

  const ref = useRef(null);

  if (!open) return null;

  return (
    <aside className={classes.root} ref={ref}>
      {children}
    </aside>
  );
}
